import { useCallback, useState } from 'react';
import { DateSelector, MoreCalculators, Result } from '../../components';
import { getZodiacSign } from '../../utils';
import './ZodiacSign.scss';

export const ZodiacSign = () => {
  const [dateOfBirth, setDateOfBirth] = useState(() => new Date('1990-01-01'));
  const [zodiacSign, setZodiacSign] = useState(() =>
    getZodiacSign(dateOfBirth)
  );
  const [showLoader, setShowLoader] = useState(false);

  const calculate = useCallback(() => {
    setShowLoader(true);
    setZodiacSign(() => getZodiacSign(dateOfBirth));
    setTimeout(() => {
      setShowLoader(false);
    }, 1000);
  }, [dateOfBirth]);

  return (
    <>
      <div className='page p-4 rounded border mb-5'>
        <h2>Zodiac Sign Finder</h2>
        <p className='mb-4'>
          Find out your Zodiac Sign based on the date of birth
        </p>
        <section className='input border rounded p-4 mb-5'>
          <DateSelector
            label='Select Your Date of Birth'
            initDate={dateOfBirth}
            setDate={setDateOfBirth}
            maxDate={new Date()}
          />
          <button className='btn btn-success d-block w-100 py-2 fw-bold' onClick={calculate}>
            Calculate
          </button>
        </section>
        <Result showLoader={showLoader}>
          <h4>Result:</h4>
          <p className='mb-0'>
            Your Zodiac Sign is{' '}
            <a
              href={`https://www.astrology.com/horoscope/daily/${zodiacSign}.html`}
              target='_blank'
              rel='noopener noreferrer'
            >
              {zodiacSign}
            </a>
          </p>
        </Result>
      </div>
      <MoreCalculators />
    </>
  );
};
